module.exports = __webpack_public_path__ + "static/media/questionoftheday-bg.8ca9d15b.png";